module.exports = __webpack_public_path__ + "img/cz.ca7ecb6a.svg";